export const childListApi = [
    {
        "id": 967,
        "title": "Pipe Cutting",
        "price": 0.45,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0225,
        "modifyDate": "2024-10-21T09:57:09.167+00:00"
    },
    {
        "id": 968,
        "title": "Guru",
        "price": 0,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0,
        "modifyDate": "2024-10-21T09:57:09.170+00:00"
    },
    {
        "id": 969,
        "title": "Solder",
        "price": 0.55,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0275,
        "modifyDate": "2025-05-28T14:04:54.413+00:00"
    },
    {
        "id": 970,
        "title": "V Pokal Solder",
        "price": 0.6,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.03,
        "modifyDate": "2024-10-21T09:57:09.173+00:00"
    },
    {
        "id": 971,
        "title": "Eaching",
        "price": 0,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0,
        "modifyDate": "2024-10-21T09:57:09.174+00:00"
    },
    {
        "id": 972,
        "title": "CNC/Laser Marking",
        "price": 1.35,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0675,
        "modifyDate": "2024-10-21T09:57:09.175+00:00"
    },
    {
        "id": 973,
        "title": "Half Round",
        "price": 0,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0,
        "modifyDate": "2024-10-21T09:57:09.177+00:00"
    },
    {
        "id": 974,
        "title": "Zigzag",
        "price": 0.25,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0125,
        "modifyDate": "2024-10-21T09:57:09.178+00:00"
    },
    {
        "id": 975,
        "title": "Acid Double & Putas",
        "price": 0.1,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.005,
        "modifyDate": "2024-10-21T09:57:09.180+00:00"
    },
    {
        "id": 976,
        "title": "Buffing",
        "price": 0,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0,
        "modifyDate": "2024-10-21T09:57:09.181+00:00"
    },
    {
        "id": 977,
        "title": "Micro Dell",
        "price": 0.3,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.015,
        "modifyDate": "2024-10-21T09:57:09.182+00:00"
    },
    {
        "id": 978,
        "title": "Dell",
        "price": 0.15,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0075,
        "modifyDate": "2024-10-21T09:57:09.184+00:00"
    },
    {
        "id": 979,
        "title": "Kangaril/Dell Kachi",
        "price": 0.1,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.005,
        "modifyDate": "2024-10-21T09:57:09.185+00:00"
    },
    {
        "id": 980,
        "title": "Diamond Dell",
        "price": 0.75,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0375,
        "modifyDate": "2024-10-21T09:57:09.187+00:00"
    },
    {
        "id": 981,
        "title": "Kanas Meena",
        "price": 1.15,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0575,
        "modifyDate": "2024-10-21T09:57:09.188+00:00"
    },
    {
        "id": 982,
        "title": "Kanas Diamond",
        "price": 0.75,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0375,
        "modifyDate": "2024-10-21T09:57:09.190+00:00"
    },
    {
        "id": 983,
        "title": "Chakri Single",
        "price": 0.5,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.025,
        "modifyDate": "2024-10-21T09:57:09.191+00:00"
    },
    {
        "id": 984,
        "title": "Chakri Full",
        "price": 0,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0,
        "modifyDate": "2024-10-21T09:57:09.193+00:00"
    },
    {
        "id": 985,
        "title": "Hole",
        "price": 0.4,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.02,
        "modifyDate": "2024-10-21T09:57:09.195+00:00"
    },
    {
        "id": 986,
        "title": "Cutting 1 Cut",
        "price": 0.15,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0075,
        "modifyDate": "2024-10-21T09:57:09.197+00:00"
    },
    {
        "id": 987,
        "title": "Cutting 2 Cut",
        "price": 0.3,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.015,
        "modifyDate": "2024-10-21T09:57:09.198+00:00"
    },
    {
        "id": 988,
        "title": "Cutting 3 Cut",
        "price": 0.45,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0225,
        "modifyDate": "2024-10-21T09:57:09.200+00:00"
    },
    {
        "id": 989,
        "title": "Cutting 4 Cut",
        "price": 0.6,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.03,
        "modifyDate": "2024-10-21T09:57:09.202+00:00"
    },
    {
        "id": 990,
        "title": "Cutting 5 Cut",
        "price": 0.75,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0375,
        "modifyDate": "2024-10-21T09:57:09.203+00:00"
    },
    {
        "id": 991,
        "title": "Cutting 6 Cut",
        "price": 0.9,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.045,
        "modifyDate": "2024-10-21T09:57:09.205+00:00"
    },
    {
        "id": 992,
        "title": "Cutting 7 Cut",
        "price": 1.05,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0525,
        "modifyDate": "2024-10-21T09:57:09.351+00:00"
    },
    {
        "id": 993,
        "title": "Cutting 8 Cut",
        "price": 1.2,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.06,
        "modifyDate": "2024-10-21T09:57:09.352+00:00"
    },
    {
        "id": 994,
        "title": "Cutting 9 Cut",
        "price": 1.35,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0675,
        "modifyDate": "2024-10-21T09:57:09.354+00:00"
    },
    {
        "id": 995,
        "title": "Cutting 10 Cut",
        "price": 1.5,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.075,
        "modifyDate": "2024-10-21T09:57:09.355+00:00"
    },
    {
        "id": 996,
        "title": "Diamond Kachi",
        "price": 0,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0,
        "modifyDate": "2024-10-21T09:57:09.357+00:00"
    },
    {
        "id": 997,
        "title": "Hend Cutting Single",
        "price": 1,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.05,
        "modifyDate": "2024-10-21T09:57:09.358+00:00"
    },
    {
        "id": 998,
        "title": "Hend Cutting Full",
        "price": 2.5,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.125,
        "modifyDate": "2024-10-21T09:57:09.360+00:00"
    },
    {
        "id": 999,
        "title": "Earring Die Cutting",
        "price": 2.75,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.1375,
        "modifyDate": "2024-10-21T09:57:09.363+00:00"
    },
    {
        "id": 1000,
        "title": "Earring Solder",
        "price": 2,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.1,
        "modifyDate": "2024-10-21T09:57:09.365+00:00"
    },
    {
        "id": 1001,
        "title": "Plating Gold Plated",
        "price": 0.25,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0125,
        "modifyDate": "2024-10-21T09:57:09.367+00:00"
    },
    {
        "id": 1002,
        "title": "Plating Gold Plated & Meena",
        "price": 1.85,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0925,
        "modifyDate": "2024-10-21T09:57:09.369+00:00"
    },
    {
        "id": 1003,
        "title": "Plating Gold Plated & Chrome",
        "price": 2,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.1,
        "modifyDate": "2024-10-21T09:57:09.371+00:00"
    },
    {
        "id": 1004,
        "title": "Plating Bright Silver",
        "price": 3,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.15,
        "modifyDate": "2024-10-21T09:57:09.373+00:00"
    },
    {
        "id": 1005,
        "title": "Plating Rhodium\r\n",
        "price": 1.25,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0625,
        "modifyDate": "2024-10-21T09:57:09.375+00:00"
    },
    {
        "id": 1006,
        "title": "Plating Micro Gold\r\n",
        "price": 6.5,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.325,
        "modifyDate": "2024-10-21T09:57:09.377+00:00"
    },
    {
        "id": 1007,
        "title": "Plating Rose Gold\r\n",
        "price": 6.5,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.325,
        "modifyDate": "2024-10-21T09:57:09.379+00:00"
    },
    {
        "id": 1008,
        "title": "Plating 3tone\r\n",
        "price": 7,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.35,
        "modifyDate": "2024-10-21T09:57:09.381+00:00"
    },
    {
        "id": 1009,
        "title": "Plating Nickel Die G",
        "price": 0,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0,
        "modifyDate": "2024-10-21T09:57:09.383+00:00"
    },
    {
        "id": 1010,
        "title": "Extra Work\r\n",
        "price": 0.25,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0125,
        "modifyDate": "2024-10-21T09:57:09.385+00:00"
    },
    {
        "id": 1011,
        "title": "MFG. Transport\r\n",
        "price": 0.15,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.0075,
        "modifyDate": "2024-10-21T09:57:09.387+00:00"
    },
    {
        "id": 1012,
        "title": "ABC Charges\r\n",
        "price": 0.5,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.025,
        "modifyDate": "2024-10-21T09:57:09.389+00:00"
    },
    {
        "id": 1013,
        "title": "Pola 1 Colour\r\n",
        "price": 2.25,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.1125,
        "modifyDate": "2024-10-21T09:57:09.390+00:00"
    },
    {
        "id": 1014,
        "title": "Pola 2 Colour\r\n",
        "price": 3.25,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.1625,
        "modifyDate": "2024-10-21T09:57:09.392+00:00"
    },
    {
        "id": 1015,
        "title": "Regular Pawala Labour",
        "price": 2.8,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.14,
        "modifyDate": "2024-10-21T09:57:09.394+00:00"
    },
    {
        "id": 1016,
        "title": "Pawala Labour",
        "price": 2.8,
        "taxPercentage": 5,
        "hsncode": "998893",
        "tax": 0.14,
        "modifyDate": "2024-10-21T09:57:09.395+00:00"
    }
]